import { NUMBER_FORMATS } from '../constants';

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', NUMBER_FORMATS.CURRENCY).format(value);
};

export const formatPercentage = (value: number, decimals = 2): string => {
  return `${value.toFixed(decimals)}%`;
};

export const formatNetFee = (netFee: number, isCpm: boolean): string => {
  if (!Number.isFinite(netFee)) {
    return isCpm ? formatCurrency(0) : formatPercentage(0);
  }

  return isCpm ? formatCurrency(netFee) : formatPercentage(netFee);
};
